import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1, e as esm} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {r as require$$3} from "./clsx.m-5dc7436b.js";
import {c as core} from "./index-0a000c27.js";
import {u as useThemeProps_1, s as styled_1} from "./useThemeProps-ef190a94.js";
import {B as ButtonBase} from "./index-ef2a811c.js";
import {u as useEnhancedEffect} from "./useEnhancedEffect-d69b40f2.js";
import {u as useForkRef} from "./useForkRef-b591be37.js";
import {L as ListContext_1} from "./ListContext-0f0f18c4.js";
import _jsxRuntime from "react/jsx-runtime";
var listItemButtonClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getListItemButtonUtilityClass = getListItemButtonUtilityClass;
  function getListItemButtonUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiListItemButton", slot);
  }
  const listItemButtonClasses = (0, core.generateUtilityClasses)("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
  var _default = listItemButtonClasses;
  exports.default = _default;
});
var ListItemButton_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.overridesResolver = exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = _interopRequireWildcard(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _ButtonBase = interopRequireDefault(ButtonBase);
  var _useEnhancedEffect = interopRequireDefault(useEnhancedEffect);
  var _useForkRef = interopRequireDefault(useForkRef);
  var _ListContext = interopRequireDefault(ListContext_1);
  var _listItemButtonClasses = _interopRequireWildcard(listItemButtonClasses_1);
  const _excluded = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const overridesResolver = (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
  };
  exports.overridesResolver = overridesResolver;
  const useUtilityClasses = (ownerState) => {
    const {
      alignItems,
      classes,
      dense,
      disabled,
      disableGutters,
      divider,
      selected
    } = ownerState;
    const slots = {
      root: ["root", dense && "dense", !disableGutters && "gutters", divider && "divider", disabled && "disabled", alignItems === "flex-start" && "alignItemsFlexStart", selected && "selected"]
    };
    const composedClasses = (0, core.unstable_composeClasses)(slots, _listItemButtonClasses.getListItemButtonUtilityClass, classes);
    return (0, _extends2.default)({}, classes, composedClasses);
  };
  const ListItemButtonRoot = (0, _styled.default)(_ButtonBase.default, {
    shouldForwardProp: (prop) => (0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    position: "relative",
    textDecoration: "none",
    boxSizing: "border-box",
    textAlign: "left",
    paddingTop: 8,
    paddingBottom: 8,
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shortest
    }),
    "&:hover": {
      textDecoration: "none",
      backgroundColor: theme.palette.action.hover,
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${_listItemButtonClasses.default.selected}`]: {
      backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      [`&.${_listItemButtonClasses.default.focusVisible}`]: {
        backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      }
    },
    [`&.${_listItemButtonClasses.default.selected}:hover`]: {
      backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: (0, esm.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
      }
    },
    [`&.${_listItemButtonClasses.default.focusVisible}`]: {
      backgroundColor: theme.palette.action.focus
    },
    [`&.${_listItemButtonClasses.default.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity
    }
  }, ownerState.divider && {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundClip: "padding-box"
  }, ownerState.alignItems === "flex-start" && {
    alignItems: "flex-start"
  }, !ownerState.disableGutters && {
    paddingLeft: 16,
    paddingRight: 16
  }, ownerState.dense && {
    paddingTop: 4,
    paddingBottom: 4
  }));
  const ListItemButton2 = /* @__PURE__ */ React$1.forwardRef(function ListItemButton3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiListItemButton"
    });
    const {
      alignItems = "center",
      autoFocus = false,
      component = "div",
      children,
      dense = false,
      disableGutters = false,
      divider = false,
      focusVisibleClassName,
      selected = false
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const context = React$1.useContext(_ListContext.default);
    const childContext = {
      dense: dense || context.dense || false,
      alignItems,
      disableGutters
    };
    const listItemRef = React$1.useRef(null);
    (0, _useEnhancedEffect.default)(() => {
      if (autoFocus) {
        if (listItemRef.current) {
          listItemRef.current.focus();
        }
      }
    }, [autoFocus]);
    const ownerState = (0, _extends2.default)({}, props, {
      alignItems,
      dense: childContext.dense,
      disableGutters,
      divider,
      selected
    });
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRef.default)(listItemRef, ref);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_ListContext.default.Provider, {
      value: childContext,
      children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ListItemButtonRoot, (0, _extends2.default)({
        ref: handleRef,
        component,
        focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
        ownerState
      }, other, {
        classes,
        children
      }))
    });
  });
  var _default = ListItemButton2;
  exports.default = _default;
});
var ListItemButton = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    listItemButtonClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _ListItemButton.default;
    }
  });
  Object.defineProperty(exports, "listItemButtonClasses", {
    enumerable: true,
    get: function() {
      return _listItemButtonClasses.default;
    }
  });
  var _ListItemButton = interopRequireDefault(ListItemButton_1);
  var _listItemButtonClasses = _interopRequireWildcard(listItemButtonClasses_1);
  Object.keys(_listItemButtonClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _listItemButtonClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _listItemButtonClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(ListItemButton);
export {ListItemButton as L, __pika_web_default_export_for_treeshaking__ as _};
